import { inject, Injectable, isDevMode } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { IEidosExternalApp } from '@eidos/models/eidos-external-app.interface';
import { assign, merge } from 'lodash';
import { BehaviorSubject } from 'rxjs';
import { IEidosEnvironment } from './environment.interface';
import { StorageService } from '@app/core/services/storage/storage.service';
import { EMPTY_CONFIG } from '@app/core/models/configuration.model';
declare const eidosConfiguration: IEidosEnvironment;

@Injectable({
  providedIn: 'root'
})
export class EidosConfigService {
  /**
   * Current configuration
   *
   * @type {BehaviorSubject<IEidosEnvironment>}
   * @memberof EidosConfigService
   */
  public currentConfig: BehaviorSubject<IEidosEnvironment>;
  /**
   * External apps from current local configuration
   *
   * @type {BehaviorSubject<Array<IEidosExternalApp>>}
   * @memberof EidosConfigService
   */
  public currentlocalConfigExternalApps: BehaviorSubject<Array<IEidosExternalApp>>;
  /**
   * Current modules configuration
   *
   * @type {BehaviorSubject<Array<any>>}
   * @memberof EidosConfigService
   */
  public currentModulesConfig: BehaviorSubject<Array<any>> = new BehaviorSubject<Array<any>>([]);

  private storage:StorageService = inject(StorageService);

  constructor(
    private titleService: Title
  ) {

    const defaultConfig = Object.assign({},EMPTY_CONFIG);
    let config = assign(merge(defaultConfig, this.getCustomConfiguration()), this.getCustomConfiguration());
    this.storage.configuration.next(config);
    let localConfigExternalApps: Array<IEidosExternalApp> = [];

    if (isDevMode()) {
      try {

        // Read local custom configuration
        // @ts-ignore
        const eidosLocalConfiguration = require('../../../configurations/eidos-config.local.js').eidosConfiguration;
        if (typeof eidosLocalConfiguration !== 'undefined') {
          // Read local external apps configuration
          // @ts-ignore
          const localExternalApps = eidosLocalConfiguration.externalApps;
          if (typeof localExternalApps !== 'undefined') {
            localConfigExternalApps = Object.assign(localConfigExternalApps, localExternalApps);
          }

          // Update config and ext apps from local configuration
          //config = Object.assign(config, eidosLocalConfiguration);
          config = merge(defaultConfig, eidosLocalConfiguration);
          this.currentlocalConfigExternalApps = new BehaviorSubject<Array<IEidosExternalApp>>(localConfigExternalApps);
        }
      } catch (ex) {
        console.log('No local configuration found. No config property will be overwritten.');
      }
      console.log("Go to /eidos/readme to check current configuration");
    }

    this.currentConfig = new BehaviorSubject<IEidosEnvironment>(config);
    this.currentModulesConfig.next(config.modules);
    this.currentlocalConfigExternalApps = new BehaviorSubject<Array<IEidosExternalApp>>(localConfigExternalApps);
    this.titleService.setTitle(config.applicationTitle);
  }

  /**
   * Get configuration from file
   *
   * @private
   * @return {*}  {*}
   * @memberof EidosConfigService
   */
  private getCustomConfiguration(): any {
    if (typeof eidosConfiguration !== 'undefined') {
      // Resolve URLs
      eidosConfiguration.urlAPI = eidosConfiguration.urlAPI.toLocaleLowerCase().replace("~", eidosConfiguration.baseUrl);
      if (eidosConfiguration.windowsAuth) {
        eidosConfiguration.windowsAuth.authorizationUrl = eidosConfiguration.windowsAuth.authorizationUrl.toLocaleLowerCase().replace("~", eidosConfiguration.baseUrl);
      }
      return eidosConfiguration;
    } else {
      console.log('Configuration missing');
      return {};
    }
  }
}
